import React from "react";
import { Clock, Menu, Loader2 } from "lucide-react";

/**
 * TestHeader
 * Sticky top bar: title, elapsed time, overall progress bar, autosave status.
 * On mobile, exposes a hamburger button that toggles the sidebar drawer
 * (wired up by the parent via onToggleSidebar).
 */
const TestHeader = ({
  title,
  progressPercent,
  elapsedLabel,
  timeRemainingLabel,
  isLowTime,
  saveStatus, // 'saved' | 'saving'
  onToggleSidebar,
}) => {
  return (
    <header className="test-header">
      <button
        type="button"
        className="header-menu-btn"
        aria-label="Toggle question navigator"
        onClick={onToggleSidebar}
      >
        <Menu />
      </button>

      <div className="header-title-block">
        <h2>{title}</h2>
        <div className="header-subrow">{progressPercent}% complete</div>
      </div>

      <div
        className="header-progress-track"
        role="progressbar"
        aria-valuenow={progressPercent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="header-progress-fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      <div className="header-meta">
        <div className={`meta-item ${isLowTime ? "time-low" : ""}`}>
          <Clock />
          <span>{timeRemainingLabel ?? elapsedLabel}</span>
        </div>

        <div
          className={`save-status ${saveStatus === "saving" ? "saving" : ""}`}
        >
          {saveStatus === "saving" ? (
            <Loader2 className="save-dot-spin" size={12} />
          ) : (
            <span className="save-dot" />
          )}
          <span>{saveStatus === "saving" ? "Saving…" : "Saved"}</span>
        </div>
      </div>
    </header>
  );
};

export default TestHeader;
